/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { createContext, useContext, useState } from 'react';
import { Toaster, toast } from 'sonner';
import ReactDOM from 'react-dom';

// Estilo CSS para ocultar cualquier sección no deseada
const hiddenStyle = {
  display: 'none',
};

const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toaster, setToaster] = useState(null);

  const showToast = (message) => {
    toast(message);
  };

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}
      {ReactDOM.createPortal(
        <Toaster
          position="top-center"
          richColors
          expand={false}
        />,
        document.body
      )}
      {/* Sección oculta para prevenir elementos visibles no deseados */}
      <section style={hiddenStyle}></section>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);